module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "ql-pages-container",
    staticStyle: {
      "overflow": "auto",
      "justify-content": "center"
    }
  }, [(_vm.selectedPageType === 'no' || (_vm.selectedPageType === 'even' && ((_vm.totalPages % 2 === 0 && _vm.totalPages === _vm.currentPage) || _vm.currentPage === 1))) ? _c('md-layout', {
    staticClass: "ql-page-layout",
    attrs: {
      "md-row": "",
      "md-gutter": "12"
    }
  }, [_c('div', {
    staticClass: "ql-pages-inner",
    attrs: {
      "id": ("pageNumber" + _vm.currentPage)
    }
  }, [(_vm.pageReady && _vm.displayLayerCues.length > 0) ? _c('svg', {
    staticClass: "ql-page-graphics",
    class: {
      withBookmarkNav: _vm.bookmarkNavOpened
    },
    style: ({
      height: (_vm.svgTrueHeight + "px"),
      overflow: ("" + (_vm.showMarginView ? 'visible' : 'hidden'))
    }),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1"
    }
  }, _vm._l((_vm.visiblePositionedCues), function(cue) {
    return _c('line', {
      key: cue.id,
      staticClass: "ql-page-cue-line",
      style: (_vm.cueLineOpacityStyle(cue)),
      attrs: {
        "x1": cue.lineX1,
        "y1": cue.lineY1,
        "x2": cue.lineX2,
        "y2": cue.lineY2,
        "stroke-width": "1",
        "stroke-opacity": _vm.lineOpacity(cue)
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('project-page', {
    key: _vm.currentPage,
    staticClass: "md-flex ql-project-page",
    style: ({
      order: _vm.pdfPaneOrderByCuePlacement()
    }),
    attrs: {
      "page": _vm.currentProjectPage,
      "locked": _vm.locked,
      "positionedCues": _vm.positionedCues,
      "svgTrueHeight": _vm.svgTrueHeight,
      "showMode": _vm.showMode,
      "bookmarked": _vm.currentPageBookmarked,
      "bookmarkNavOpened": _vm.bookmarkNavOpened,
      "issrc": _vm.project.issrc,
      "openCues": _vm.openCues,
      "selectedElement": _vm.selectedElement
    },
    on: {
      "setSelectedElement": _vm.setSelectedElement,
      "updatePageHistory": _vm.updatePageHistory,
      "pageLoaded": _vm.pageLoaded,
      "addedCue": _vm.addedCue,
      "deletedCue": _vm.deletedCue,
      "updatedCue": _vm.updatedCue,
      "copyElement": _vm.copyElement,
      "toggleBookmarkNav": _vm.toggleBookmarkNav,
      "openBookmarkNav": _vm.openBookmarkNav,
      "setBookmarkTab": _vm.setBookmarkTab
    }
  }), _vm._v(" "), (_vm.displayLayerCues.length > 0) ? _c('project-cue-list', {
    style: (_vm.cuesListStyles()),
    attrs: {
      "currentPage": _vm.currentPage,
      "cues": _vm.visiblePositionedCues,
      "locked": _vm.locked,
      "openCues": _vm.openCues,
      "globalCuesLength": _vm.cuesLength,
      "cuesListWidth": _vm.cuesListWidth,
      "svgContentWidth": _vm.svgContentWidth,
      "svgTrueHeight": _vm.svgTrueHeight
    },
    on: {
      "openCue": _vm.openCue,
      "closeCue": _vm.closeCue,
      "destroy": _vm.deletedCue,
      "updatedCue": _vm.updatedCue
    }
  }) : _vm._e()], 1)]) : _c('div', {
    staticClass: "spread"
  }, [_c('md-layout', {
    staticClass: "ql-page-layout",
    attrs: {
      "md-row": "",
      "md-gutter": "6"
    }
  }, [_c('div', {
    staticClass: "ql-pages-inner",
    attrs: {
      "id": ("pageNumber" + _vm.currentPage)
    }
  }, [(_vm.pageReady && _vm.displayLayerCues.length > 0) ? _c('svg', {
    staticClass: "ql-page-graphics",
    class: {
      withBookmarkNav: _vm.bookmarkNavOpened
    },
    style: ({
      height: (_vm.svgTrueHeight + "px")
    }),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1"
    }
  }, _vm._l((_vm.visiblePositionedCues), function(cue) {
    return _c('line', {
      key: cue.id,
      staticClass: "ql-page-cue-line",
      style: (_vm.cueLineOpacityStyle(cue)),
      attrs: {
        "x1": cue.lineX1,
        "y1": cue.lineY1,
        "x2": cue.lineX2,
        "y2": cue.lineY2,
        "stroke-width": "1",
        "stroke-opacity": _vm.lineOpacity(cue)
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('project-page', {
    key: _vm.currentPage,
    staticClass: "md-flex ql-project-page",
    style: ({
      order: _vm.pdfPaneOrderByCuePlacement()
    }),
    attrs: {
      "page": _vm.currentProjectPage,
      "locked": _vm.locked,
      "positionedCues": _vm.positionedCues,
      "svgTrueHeight": _vm.svgTrueHeight,
      "showMode": _vm.showMode,
      "selectedElement": _vm.selectedElement,
      "bookmarked": _vm.currentPageBookmarked,
      "bookmarkNavOpened": _vm.bookmarkNavOpened,
      "issrc": _vm.project.issrc,
      "openCues": _vm.openCues
    },
    on: {
      "setSelectedElement": _vm.setSelectedElement,
      "updatePageHistory": _vm.updatePageHistory,
      "pageLoaded": _vm.pageLoaded,
      "addedCue": _vm.addedCue,
      "deletedCue": _vm.deletedCue,
      "copyElement": _vm.copyElement,
      "updatedCue": _vm.updatedCue,
      "toggleBookmarkNav": _vm.toggleBookmarkNav,
      "openBookmarkNav": _vm.openBookmarkNav,
      "setBookmarkTab": _vm.setBookmarkTab
    }
  }), _vm._v(" "), (_vm.displayLayerCues.length > 0) ? _c('project-cue-list', {
    style: (_vm.cuesListStyles()),
    attrs: {
      "currentPage": _vm.currentPage,
      "cues": _vm.visiblePositionedCues,
      "locked": _vm.locked,
      "openCues": _vm.openCues,
      "globalCuesLength": _vm.cuesLength,
      "cuesListWidth": _vm.cuesListWidth,
      "svgContentWidth": _vm.svgContentWidth,
      "svgTrueHeight": _vm.svgTrueHeight
    },
    on: {
      "openCue": _vm.openCue,
      "closeCue": _vm.closeCue,
      "destroy": _vm.deletedCue,
      "updatedCue": _vm.updatedCue
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.currentPage + 1 <= _vm.totalPages) ? _c('md-layout', {
    staticClass: "ql-page-layout",
    attrs: {
      "md-row": "",
      "md-gutter": "6"
    }
  }, [_c('div', {
    staticClass: "ql-pages-inner",
    attrs: {
      "id": ("pageNumber" + (_vm.currentPage + 1))
    }
  }, [(_vm.pageReady && _vm.displayLayerNextCues.length > 0) ? _c('svg', {
    staticClass: "ql-page-graphics",
    class: {
      withBookmarkNav: _vm.bookmarkNavOpened
    },
    style: ({
      height: (_vm.svgTrueNextHeight + "px")
    }),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1"
    }
  }, _vm._l((_vm.positionedNextCues), function(cue) {
    return _c('line', {
      key: cue.id,
      staticClass: "ql-page-cue-line",
      style: (_vm.cueLineOpacityStyle(cue)),
      attrs: {
        "x1": cue.lineX1,
        "y1": cue.lineY1,
        "x2": cue.lineX2,
        "y2": cue.lineY2,
        "stroke-width": "1",
        "stroke-opacity": _vm.lineOpacity(cue)
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), _c('project-page', {
    key: _vm.currentPage + 1,
    staticClass: "md-flex ql-project-page",
    style: ({
      order: _vm.pdfPaneOrderByCuePlacement()
    }),
    attrs: {
      "page": _vm.nextProjectPage,
      "locked": _vm.locked,
      "showMode": _vm.showMode,
      "positionedCues": _vm.positionedNextCues,
      "svgTrueHeight": _vm.svgTrueHeight,
      "bookmarked": _vm.nextPageBookmarked,
      "bookmarkNavOpened": _vm.bookmarkNavOpened,
      "issrc": _vm.project.issrc,
      "openCues": _vm.openCues,
      "selectedElement": _vm.selectedElement
    },
    on: {
      "setSelectedElement": _vm.setSelectedElement,
      "updatePageHistory": _vm.updatePageHistory,
      "pageLoaded": _vm.pageLoaded,
      "copyElement": _vm.copyElement,
      "addedCue": _vm.addedCue,
      "deletedCue": _vm.deletedCue,
      "updatedCue": _vm.updatedCue,
      "toggleBookmarkNav": _vm.toggleBookmarkNav,
      "openBookmarkNav": _vm.openBookmarkNav,
      "setBookmarkTab": _vm.setBookmarkTab
    }
  }), _vm._v(" "), (_vm.displayLayerNextCues.length > 0) ? _c('project-cue-list', {
    style: (_vm.cuesListStyles()),
    attrs: {
      "currentPage": _vm.currentPage + 1,
      "cues": _vm.positionedNextCues,
      "locked": _vm.locked,
      "openCues": _vm.openCues,
      "globalCuesLength": _vm.cuesLength,
      "cuesListWidth": _vm.cuesListWidth,
      "svgContentWidth": _vm.svgContentWidth,
      "svgTrueHeight": _vm.svgTrueHeight
    },
    on: {
      "openCue": _vm.openCue,
      "closeCue": _vm.closeCue,
      "destroy": _vm.deletedCue,
      "updatedCue": _vm.updatedCue
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76ae637e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/pages.vue
// module id = 1265
// module chunks = 21